"use client";
import * as React from "react";
const SvgHomeOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m8 2.22 4 3.7v6.43h-1.6V7.41H5.6v4.94H4V5.92zM8 0 0 7.41h2.4V14h4.8V9.06h1.6V14h4.8V7.41H16z" }));
export {
  SvgHomeOutlined as default
};
